export const BROADCAST_PATH = '/api/v1/public/platform-broadcasts';
export const BROADCAST_SYSTEMS = ['workspace','cases','sessions','execution','reports','finance','followup','automation','developer-tools'];
export function broadcastPhase(item, now = Date.now()) {
  if(item.status !== 'published' || now < Date.parse(item.publishedAt) || now >= Date.parse(item.endsAt)) return null;
  if(item.kind !== 'maintenance') return now<Date.parse(item.startsAt)?null:{id:'published',persistent:false};
  const remaining=Date.parse(item.startsAt)-now;
  if(remaining<=0)return {id:'active',persistent:true};
  if(remaining<=5*60_000)return {id:'five-minutes',persistent:true};
  if(remaining<=30*60_000)return {id:'thirty-minutes',persistent:false};
  if(remaining<=60*60_000)return {id:'one-hour',persistent:false};
  if(remaining<=3*60*60_000)return {id:'three-hours',persistent:false};
  return {id:'published',persistent:false};
}
export function broadcastKey(item, phase) { return `${item.id}:${item.version}:${phase.id}`; }
export function broadcastCountdown(ms) {
  const seconds=Math.max(0,Math.ceil(ms/1000));
  return [Math.floor(seconds/3600),Math.floor(seconds/60)%60,seconds%60].map(v=>String(v).padStart(2,'0')).join(':');
}
export function validBroadcastShortcut(system,path) {
  if(!BROADCAST_SYSTEMS.includes(system)||typeof path!=='string'||path.length>400||!path.startsWith('/')||path.startsWith('//')||/[\\\x00-\x20\x7f]/.test(path))return false;
  try {
    const url=new URL(path,'https://n9.invalid');
    if(url.origin!=='https://n9.invalid'||/^\/(?:api|auth|sso|logout|control-signin)(?:\/|$)/i.test(url.pathname))return false;
    return !/%(?:0[0-9a-f]|1[0-9a-f]|7f|5c)/i.test(path);
  } catch {return false;}
}
